import { app, VERSION, WEB_PUSH_CERTIFITCATION } from "config/config";
import styles from "./styles.module.css";
import { getMessaging, getToken } from "firebase/messaging";
import { addToken } from "store/token/token.action";
import { useState } from "react";
import { Button, message } from "antd";
const HomeScreen = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleClick = async () => {
    try {
      if ("serviceWorker" in navigator) {
        setLoading(true);
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
        );
        const messaging = getMessaging(app);

        if (registration.active) {
          const token = await getToken(messaging, {
            vapidKey: WEB_PUSH_CERTIFITCATION,
            serviceWorkerRegistration: registration,
          });

          if (!token) {
            throw new Error("Không lấy được token FCM");
          }

          const resp = await addToken({ token });

          if (resp.status !== 500) {
            setDone(true);
            message.success("Thành công");
          } else {
            throw new Error("Server trả về lỗi: " + JSON.stringify(resp?.data));
          }
        } else {
          throw new Error("Service Worker chưa active");
        }
      }
    } catch (err) {
      console.error("Service Worker registration failed:", err);
    } finally {
      setLoading(false);
    }
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  // if (done) {
  //   return (
  //     <div className={styles?.["layout-container"]}>
  //       <div>Đã đăng ký nhận thông báo đến thiết bị này</div>
  //     </div>
  //   );
  // }
  return (
    <div className={styles?.["layout-container"]}>
      <div>
        <div>Đăng ký nhận tất cả thông báo đến thiết bị này</div>
        <Button
          type="primary"
          shape="round"
          size="large"
          onClick={handleClick}
          loading={loading}
          disabled={done}
        >
          Đăng ký thông báo
        </Button>
      </div>
      <div style={{ fontSize: 10 }}>Phiên bản {VERSION}</div>
    </div>
  );
};
export default HomeScreen;
